import type { ChatGroupResponse } from '../chat-module'
import { type Customer } from './Customer'
import type { CustomerBuyingPower } from './CustomerBuyingPower'
import type { CustomerOnboarding } from './CustomerOnboarding'

export * from './BuyingCapacity'
export * from './Customer'
export * from './CustomerBuyingPower'
export * from './CustomerOnboarding'
export * from './EquifaxCreditReport'

const baseURL = '/partner/customers'

export function useCustomerService() {
  return {
    fetchCustomers(query?: { accountId: string } | { customerId: string }) {
      return useAttainApi<Customer[]>(`${baseURL}/`, { method: 'GET', query })
    },
    fetchCustomer(customerId: string) {
      return useAttainApi<Customer[]>(`${baseURL}/${customerId}`, { method: 'GET' })
    },
    createCustomer(customer: Pick<Customer, 'firstName' | 'lastName' | 'email' | 'phoneNumber' | 'locale'>) {
      return useAttainApi<Customer>(`${baseURL}/`, { method: 'POST', body: customer })
    },
    updateCustomer(customer: Pick<Customer, '_id' | 'status'>) {
      const { _id, ...body } = customer
      return useAttainApi<Customer>(`${baseURL}/${_id}`, { method: 'PUT', body })
    },
    fetchBuyingPowerByCustomerId(id: string) {
      return useAttainApi<CustomerBuyingPower>(`${baseURL}/${id}/buying-power`)
        .catch((err) => {
          if (isFetchError(err) && err.statusCode === 404) return undefined
          throw err
        })
    },
    fetchOnboardingByCustomerId(id: string) {
      return useAttainApi<CustomerOnboarding>(`${baseURL}/${id}/onboarding`)
    },
    postChatGroupForCustomer(customerId: string) {
      return useAttainApi<ChatGroupResponse>(`${baseURL}/${customerId}/chat`, { method: 'POST' })
    },
  }
}
